import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../9837bffb195015a4513e93472fb398acea449d84d98f6268afd87828b663e6c1.cfe-internal.js';
import '../../../icons/index.es.js';
import { useInputGroupContext } from '../../InputGroup/fc923f7df98798752b55075d988c99381886b50e072df75d1b96be0b82f76494.cfe-internal.js';
import { useFormFieldControl } from '../../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import '../../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import concatIds from '../../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';
import ChevronDownIcon from '../../../icons/components/7c7c780956cb4e93fe69a1384927ee5fbe6526f5bb2422c9d44843841947bab7.cfe-internal.js';

var _excluded = ["label", "className", "small", "isOpen", "disabled", "onClick", "onKeyDown", "aria-describedby"];
var MenuAnchor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    className = _ref.className,
    small = _ref.small,
    isOpen = _ref.isOpen,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    externalAriaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputGroupContext = useInputGroupContext();
  var _useFormFieldControl = useFormFieldControl(),
    hasFormLabel = _useFormFieldControl.hasLabel,
    formFieldHelperTextId = _useFormFieldControl.helperTextId,
    formFieldErrorTextId = _useFormFieldControl.errorTextId;
  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    ref: ref,
    type: "button",
    className: classNames(className, styles.menuBtn, inputGroupContext.className, _defineProperty(_defineProperty(_defineProperty({}, styles.unlabelledButton, !label && label !== 0), styles.small, inputGroupContext.applySmall(small)), styles.formLabelled, hasFormLabel)),
    "aria-haspopup": "menu",
    "aria-disabled": disabled,
    "aria-describedby": internalAriaDescribedby,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.menuBtnLabel
  }, label), /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    className: classNames(styles.rightIcon, _defineProperty(_defineProperty({}, styles.small, inputGroupContext.applySmall(small)), styles.open, isOpen)),
    "aria-hidden": "true"
  }));
});

export { MenuAnchor as default };
